import React from 'react';

import { container, pin } from './styles.module.css';

const Pin = () => (
  <div className={container}>
    <img
      className={pin}
      src={`${MEDIA_ROOT}/icons/icn_pin.svg`}
      alt="Pin"
    />
  </div>
);

export default Pin;
